const $ = require("jquery");

function generateAmountJapanese(amount) {
  var digit = ["", "万", "億", "兆", "京"];
  if (!amount) {
    return "0";
  }
  var result = "";
  var amounts = String(amount)
    .replace(/(\d)(?=(\d\d\d\d)+$)/g, "$1,")
    .split(",")
    .reverse();
  for (var i = 0; i < amounts.length; i++) {
    if (!amounts[i].match(/^[0]+$/)) {
      // 先頭の0を削除
      amounts[i] = amounts[i].replace(/^[0]+/g, "");
      result = amounts[i] + digit[i] + result;
    }
  }
  return result || "0";
}

function calcAmount(target, display_target_id) {
  var amount = target.val().replace(/^[0]+/, "");
  var result = generateAmountJapanese(amount);
  $("#" + display_target_id).html(result);
}

function checkAmount(event_target, target_id, confirm_message) {
  var amount = $("#" + target_id).val();
  if (parseInt(amount) >= 500000) {
    if (confirm(confirm_message)) {
      return true;
    }
  } else {
    return true;
  }
  var submitButton = event_target.find('input[type="submit"]');
  setTimeout(function () {
    // onSubmit実行後にボタンが非活性になるので戻す
    submitButton.prop("disabled", false);
  }, 100);
  return false;
}

$(function () {
  "use strict";
  var chargeAmount = $("#charge_amount");

  chargeAmount.on("input", function () {
    calcAmount(chargeAmount, "charge_amount_text");
  });

  var adminChargeForm = $("#admin_charge");
  adminChargeForm.on("submit", function () {
    return checkAmount(
      adminChargeForm,
      "charge_amount",
      "高額のチャージです。チャージ金額が正しいことを確認してください。",
    );
  });
  adminChargeForm.find("input[type=submit]:disabled").prop("disabled", false);

  // 汎用日本語変換(入力値を日本語表記に変換)
  document.addEventListener("input", function (e) {
    if (e.target.classList.contains("js-amount-to-japanese-input")) {
      var input = e.target;
      var labels = input
        .closest(".js-amount-to-japanese-container")
        .querySelectorAll(".js-amount-to-japanese-label");
      labels.forEach(function (label) {
        var amount = input.value.replace(/^[0]+/, "");
        label.textContent = generateAmountJapanese(amount);
      });
    }
  });

  // 汎用日本語変換(データ属性から変換)
  function updateAmountToJapaneseFromData(target) {
    var amount = target.dataset.amount;
    if (amount) {
      target.textContent = generateAmountJapanese(amount);
    } else {
      target.textContent = "0";
    }
  }
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type !== "attributes") return;
      if (mutation.attributeName !== "data-amount") return;

      updateAmountToJapaneseFromData(mutation.target);
    });
  });
  var amountToJapaneseFromData = document.querySelectorAll(
    ".js-amount-to-japanese-from-data",
  );
  amountToJapaneseFromData.forEach(function (element) {
    updateAmountToJapaneseFromData(element);
    observer.observe(element, {
      attributes: true,
      attributeFilter: ["data-amount"],
    });
  });
});
